import React, { useState, useEffect, useContext, useRef } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Pagination from '@mui/material/Pagination';
import MSelect from '@mui/material/Select';
import Select from 'react-select';
import MenuItem from '@mui/material/MenuItem';
import Box from "@mui/material/Box";
import axios from "axios";
import "./../style.css";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import fav_icon from "./../Asset/New_Assert/ESO_ICON.png";

import LiquidFillGauge from "react-liquid-gauge";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { faLaptopHouse } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { Card, Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import RunReportNow from "../RunReportNow";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import CircleIcon from '@mui/icons-material/Circle';
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import { Commonfun, removeDuplicateDate } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { datezonechange } from "./../Commonfun";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";


import { AppContext } from "../../../Context/Context";
import moments from 'moment-timezone';
import Loader from "../CommonLoader";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { Link } from "react-router-dom";
import ErrorCountimg from "../Asset/esocardicon/SourceCodeAnalysis/ErrorCount.svg"
import FatalErrorCountimg from "../Asset/esocardicon/SourceCodeAnalysis/FatalErrorCount.svg"
import WarningCountimg from "../Asset/esocardicon/SourceCodeAnalysis/WarningCount.svg"
import PdfandCsv from "../PdfandCsv";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import DatagridComp from "../DatagridComp";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import UserActivityTracker from "../../../hooks/userActivityTracker";
import ScoreGauge from "../../../Components/chart/gaugeChart";
import Chart from "react-apexcharts";


export default function Codeauditlist() {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [codejobDate, setcodejobDate] = useState("");
  const [sourcePlan, setsourcePlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const [domainsecid, setDomainsecid] = useState("");
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([])
  const [Domainsectiondata, SetDomainsectiondata] = useState([])
  const [autoheightval, SetAutoheightval] = useState(false)
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [fataloutCount, setfataloutCount] = useState();
  const [erroroutCount, seterroroutCount] = useState();
  const [warningoutCount, setwarningoutCount] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [summaryData, setSummaryData] = useState({
    "overall_score": 0,
    "pie_chart": {
      "good": 0,
      "moderate": 0,
      "critical": 0
    },
    "top_5_urls": [],
    "low_5_urls": [],
    "trend": []
  });

  const navigate = useNavigate();
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value


  const apihandleClose = () => {
    setapiOpen(false);
  };


  const handleClose = () => {
    setOpen(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });
  let detailurl = `${process.env.REACT_APP_DOMAIN}source-code-detail/`;


  const checkUserPlan = async () => {
    const sourceP = await Utils("source_code_analysis", ApiToken);
    if (sourceP.status) {
      callUserdataApi();
      LoadAddFormFilterOptions();
      faqdatafun()
    }
    setsourcePlan(sourceP);
  };

  useEffect(() => {
    checkUserPlan();
    GetuserDatavalue();
  }, []);

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };

  const columns = [



    {
      field: "links__url",
      headerName: "URL",
      description: 'The URLs added under URL management',
      minWidth: 320,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      renderCell: (cardData) => {

        let baseUrl = cardData.row.links__url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.links__url.split("/").slice(3).join("/");

        return (
          <>

            <Tooltip title={cardData.row.links}>
              <div className="prefered_url_external02">
                <a target="_blank" className="table-link" href={cardData?.row?.links__url}>
                  <span className="spanlink" style={{ display: 'flex', alignItems: 'baseline' }}>
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </>
        );

      },
    },

    {
      field: "fatal_error",
      headerName: "Fatal Error",
      description: 'The total number of fatal errors present on the web page.',
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "error_count",
      headerName: "Errors",
      description: 'The total number of errors present on the web page.',
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "warning_count",
      headerName: "Warnings",
      description: 'The total number of warnings present on the web page',
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
    },
    {
      field: "View",
      headerName: "View",
      minWidth: 200,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      renderCell: (cardData) => {
        return (
          <a href={detailurl + `${cardData.row.id}` + "/" + `${jobidData}`}>
            <button className="view-report-button">
              View Report
            </button>
          </a>
        );
      },
    },
  ];

  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "", domainsecdata = "") => {
    setLoading(true);
    setTableLoading(true);
    // if (domainsecdata == "")
    //   domainsecdata = Domainsectiondata;
    if (jobid == "")
      jobid = jobidData;
    const datavalue = await axios.get(
      `${process.env.REACT_APP_API_URL}technical/v2/sourcecode_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobid}&domain_section_id=${domainsecdata}`, {

      headers: {
        Authorization: `${ApiToken}`,
      },
    }
    ).catch((error) => {
      if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
        setapiOpen(true);
        setapierrorMsg(error?.response?.data?.error)
      }
      else if (error?.code == "ERR_NETWORK") {
        navigate('/errorpages')
      }
    });

    if (jobidData == "") {
      const completevalues = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?job_type=source_code_analysis&user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${esodata.sectiondomaindata.value}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        setLoading(false);
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      // var Selectedmets = [];
      if (completevalues?.data?.jobs?.length > 0) {
        // completevalues?.data?.jobs.forEach((element) => {
        //   Selectedmets.push({
        //     value: element.id,
        //     label: datezonechange(element.completed_at),
        //   });
        // });
        const uniqueByCompletedAt = removeDuplicateDate(completevalues?.data?.jobs);
        SetdEngineoption(uniqueByCompletedAt[0])
        setprevdEngineoption(uniqueByCompletedAt[0])
        setcompletedate(uniqueByCompletedAt);
      }

    }

    const dataval = datavalue?.data?.table_data;

    setwarningoutCount(datavalue?.data?.warning_count)
    seterroroutCount(datavalue?.data?.error_count)
    setfataloutCount(datavalue?.data?.fatal_error_count)
    if (datavalue?.data?.job_date)
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
    else
      setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))

    if (dataval) {
      SetAutoheightval(false)
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });
      setCardData(newData);
      setcodejobDate(datavalue?.data?.job_date)
      setSelectval(datavalue?.data?.job_id)
      setjobidData(datavalue?.data?.job_id)
    }
    else {
      setCardData("")
      SetAutoheightval(true)
    }
    if (datavalue?.data) {
      setSummaryData({
        "overall_score": datavalue?.data?.overall_score || 0,
        "pie_chart": {
          "good": datavalue?.data?.pie_chart?.good || 0,
          "moderate": datavalue?.data?.pie_chart?.moderate || 0,
          "critical": datavalue?.data?.pie_chart?.critical || 0
        },
        "top_5_urls": datavalue?.data?.top_5_urls || [],
        "low_5_urls": datavalue?.data?.low_5_urls || [],
        "trend": datavalue?.data?.trend || []
      })
    }
    setTableLoading(false);
    setLoading(false);
  };

  const reportNow = async () => {
    setLoading(true);
    var errs = 1;
    let errors = {};

    if (selectval == "") {
      errors.dateerror = "This field is required.";
      errs = 2;
      setLoading(false);

    } else {
      errors.dateerror = "";
      errs = 1;
      setValidation(errors);
    }
    if (errs == 2) {
      return setValidation(errors);
    }
    setjobidData(selectval?.value);
    setIsOpen(false);
    setprevdEngineoption(dEngineoption);
    callUserdataApi(selectval?.value);
    setLoading(false);
  };
  function openModal() {
    if (sourcePlan.status) {
      setIsOpen(true);
    }
  }
  function closeModal() {
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);
  }
  const [RunReportPopShow, SetRunReportPopShow] = useState(false)
  const [RunReportType, SetRunReportType] = useState('source_code_analysis')
  const [dEngineoption, SetdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  const [prevdEngineoption, setprevdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });


  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {

      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/v2/sourcecode_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidData}&formats=pdf&domain_section_id=${Domainsectiondata}&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("SourceCode", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }

    } catch (error) {
      if (error.code == "ERR_NETWORK") {
        navigate('/*')
      }
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/v2/sourcecode_summary_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobidData}&formats=csv&domain_section_id=${Domainsectiondata}&timezone=${timezoneval()}`, {

        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("SourceCode", "csv", ApiToken, esodata.domaindata.value.header_selected);

        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }

      }
    } catch (error) {
      if (error.code == "ERR_NETWORK") {
        navigate('/*')
      }
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }
  const LoadAddFormFilterOptions = async () => {
    SetSectionOptions([]);
    try {
      const doaminsectiondatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_domain_sections/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {

        if (doaminsectiondatavalue?.data?.domain_sections) {

          SetDoaminSectionUrl(doaminsectiondatavalue.data.domain_sections)
          var Sections = [];
          doaminsectiondatavalue.data.domain_sections.forEach((element) => {
            Sections.push({ label: element.name, value: element.id });
          });
          SetSectionOptions(Sections);
        }
      }
    } catch (err) {
      if (err.code == "ERR_NETWORK") {
        navigate('/*')
      }
    }
  }
  const SetSectionNameHandle = (passvalue) => {
    if (passvalue) {
      SetDomainsectiondata(passvalue.value)
      callUserdataApi("", passvalue.value);
    } else {
      SetDomainsectiondata("")
      callUserdataApi();
    }
  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=20`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) {
      if (err.code == "ERR_NETWORK") {
        navigate('/*')
      }
    }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };


  // const cardDatas = [
  //   { title: "Fatal Error Count", value: fataloutCount, iconSrc: FatalErrorCountimg, altText: "Fatal Error Count" },
  //   { title: "Error Count", value: erroroutCount, iconSrc: ErrorCountimg, altText: "Error Count" },
  //   { title: "Warning Count", value: warningoutCount, iconSrc: WarningCountimg, altText: "Warning Count" },
  // ];

  const cardDatas = [
    {

      value: fataloutCount || 0,
      title: "Fatal Error Count",
      // badge: "SEO",
      iconSrc: FatalErrorCountimg,
      iconColor: 1,
      bgColor: 1,

    },
    {

      value: erroroutCount || 0,
      title: "Error Count",
      // badge: "TRAFFIC",
      iconSrc: ErrorCountimg,
      iconColor: 2,
      bgColor: 2,

    },
    {

      value: warningoutCount || 0,
      title: "Warning Count",
      // badge: "TRAFFIC",
      iconSrc: WarningCountimg,
      iconColor: 3,
      bgColor: 3,

    },

  ];

  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuItemStyle = {
    padding: "10px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    backgroundColor: "#fff",
    transition: "background 0.2s",
  };


  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const gaugeChart = () => {
    return (
      <div>
        {/* <span>Most Critical issue category</span> */}
        <ScoreGauge score={summaryData.overall_score} width={'450px'} />
      </div>
    )
  }

  const urls = Array.isArray(summaryData?.top_5_urls)
    ? summaryData.top_5_urls
    : [];
  const urls1 = Array.isArray(summaryData?.low_5_urls)
    ? summaryData.low_5_urls
    : [];

  const chartOptions = (url) => {

    return {
      chart: {
        type: "bar",
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: true, // better for long URLs
          barHeight: "60%"
        }
      },
      xaxis: {
        categories: urls?.map(item =>
          item.links__url.length > 40 ? item.links__url.slice(0, 40) + "..." : item.links__url
        ) || [],
        labels: {
          show: false   // 👈 hides numbers/text on x-axis
        },
        axisBorder: {
          show: false   // optional: remove axis line
        },
        axisTicks: {
          show: false   // optional: remove ticks
        }
      },
      yaxis: {
        labels: {
          maxWidth: 150
        }
      },
      grid: {
        padding: {
          left: 20,
          right: 20
        }
      },
      tooltip: {
        x: {
          formatter: (val, opts) => urls[opts.dataPointIndex]?.links__url
        },
        y: {
          formatter: (val) => val
        }
      }
    };
  }

  const chartSeries = (url) => {
    return [
      {
        name: "Error Count",
        data: urls?.map(item => item.error_count) || []
      },
      {
        name: "Warning Count",
        data: urls?.map(item => item.warning_count) || []
      },
      {
        name: "Fatal Error",
        data: urls?.map(item => item.fatal_error) || []
      }
    ];
  }
  const trendChartOptions = (url) => {

    return {
      chart: {
        type: "bar",
        height: 400,
        width: "100%",
        toolbar: { show: false }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "60%",
        }
      },
      responsive: [{
        breakpoint: 768,
        options: {
          chart: {
            width: "100%",
            height: 350,
          },
          legend: { show: false },
          dataLabels: { enabled: false }
        }
      }],
      xaxis: {
        type: "category",
        categories: url?.map(item => item.date) || [],

        crosshairs: {
          show: false
        },
        labels: {
          offsetX: 50,
          style: { fontSize: "12px" }
        }
      },
      yaxis: {
        labels: { formatter: (val) => Math.round(val) },
      },
      dataLabels: { enabled: false },
      colors: ["#008ffb", "#00e396", "#feb019", "#ff4560", "#775dd0", "#037e88", "#cc00b3"]
    };
  }

  const trendChartSeries = (url) => {
    return [
      {
        name: "Error Count",
        data: urls?.map(item => item.error_count) || []
      },
      {
        name: "Warning Count",
        data: urls?.map(item => item.warning_count) || []
      },
      {
        name: "Fatal Error",
        data: urls?.map(item => item.fatal_error) || []
      }
    ];
  }


  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Source Code Analysis</title>
      </Helmet>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      {loading === true ? <Loader /> : null}


      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Source Code Analysis
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Technical' },
                      { title: 'Source Code Analysis', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="drop_down_button" >
                <Select
                  options={SectionOptions}
                  name="name"
                  onChange={SetSectionNameHandle}
                  placeholder="Domain Section"
                  isClearable
                  styles={customDropdownStyles()}
                  menuPortalTarget={document.body}
                  classNamePrefix="common-domain-dropdown_color"
                />
                <button
                  title="Run Report"
                  className="btn_dashboard"
                  onClick={() => {
                    if (first.statusDomain) {
                      setcheckD(first.statusDomain);
                    } else {
                      setfaqData(2)
                      setToggle(false)
                      SetRunReportPopShow(true);
                    }
                  }}
                  disabled={!sourcePlan.status}
                >
                  Run Report Now
                </button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_hdr_content">
                <div className="box_wrap">
                  <div>
                    <h1></h1>
                    <p></p>
                  </div>
                  <div className="common-card-container" style={{ justifyContent: "center" }}>
                    {cardDatas.map(({ title, value, iconSrc, altText }) => (
                      <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
                    ))}
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container> */}

      <Container maxWidth={false} className="dashboard-card-container">
        <Box>
          <Grid container spacing={3} className="dashboard-box-card">
            <Grid container spacing={3} xs={12} md={4} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={6} md={12} key={item.id}>
                  <Commoncard
                    item={item}
                    nonclikable={true}
                  />
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  borderRadius: "16px",
                  boxShadow: "0 6px 16px rgba(0, 0, 0, 0.08)",
                  transition: "0.3s",
                  cursor: "default",
                  height: "100%",
                  // border: 1px solid #e0e0e0;
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.10)",
                  },
                  overflow: "hidden",
                  border: "none"
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#d1fae5',
                    p: 2.5,
                    // display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >

                  <Box
                    sx={{
                      // backgroundColor: '#7c3aed',
                      color: "#059669",
                      // p: 1.5,
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "1.5rem",
                    }}
                  >
                    {/* {icon} */}
                    {gaugeChart()}
                  </Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 700,
                      fontSize: "3rem",
                      background: "linear-gradient(to right, #1f2937, #4b5563)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      textShadow: "0 1px 1px rgba(0,0,0,0.1)",
                      letterSpacing: 1,
                    }}
                  >
                    <div style={{ justifySelf: 'center', marginTop: '1rem' }}>{summaryData.overall_score}<span style={{ fontSize: '14px', marginLeft: '5px' }}>out of 100</span></div>
                  </Typography>
                </Box>

                <Box
                  sx={{
                    background: "#fff",
                    px: 2.5,
                    py: 3,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    textTransform: "uppercase",
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "0.85rem", color: "#1f2937" }}
                  >
                    Overall Score
                  </Typography>
                </Box>
              </Card>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Top 5 URLs</Typography>
                <Chart
                  options={chartOptions(urls)}
                  series={chartSeries(urls)}
                  type="bar"
                  height={350}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Trend Analysis</Typography>
                <Chart
                  options={trendChartOptions(summaryData.trend || [])}
                  series={trendChartSeries(summaryData.trend || [])}
                  type="line"
                  height={350}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Category Wise Issue</Typography>
                <Chart
                  type="pie"
                  height={380}
                  series={Object.values(summaryData.pie_chart)}
                  options={{
                    labels: Object.keys(summaryData.pie_chart),
                    legend: { position: 'bottom', fontSize: '10px' },
                    dataLabels: { enabled: false }
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '400px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Low 5 URLs</Typography>
                <Chart
                  options={chartOptions(urls1)}
                  series={chartSeries(urls1)}
                  type="bar"
                  height={350}
                />
              </Box>
            </Grid>

          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {sourcePlan.status ?
                  <div>


                    <DatagridComp
                      columns={columns}
                      rows={rows}
                      autoheightval={autoheightval}
                      datagridval={2}
                      columnFreezeWidth={[0]}
                      tableLoading={tableLoading}
                      handleModelPopUp={handleModelPopUp}
                      handleDownlodingCSV={handleDownlodingCSV}
                      handleDownlodingPDF={handleDownlodingPDF}
                      customFilter={true}
                      DownloadShowFile={true}
                      DownloadShowPDF={1}
                      DownloadShowCSV={2}
                    />
                  </div> : <Freeaudit planStatus={sourcePlan} />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2026 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand"> Elite site Optimizer</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
                <p>{/* Add content if needed */}</p>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <div className="cnt_audit_outer_wrap src-detail">
        {toggle && (
          <Rightsidebar
            close={() => setToggle(false)}
            setToggle={setToggle}
            initialfaqDateval={initialfaqDateval}
          />
        )}
        {/* <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Technical' },
            { title: 'Source Code Analysis', activeColor: true }
          ]} />
          <div className="exportpdf_outer">
            <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
              <QuestionMarkIcon />

            </button>
            {sourcePlan.status &&
              <>
                <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                  csvdown={csvdown} pdfdown={pdfdown} />
              </>
            }
          </div>
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <div style={{ display: "flex" }}>
              <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f" }}>Source Code Analysis</h2>
              <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={openModal} />
              </span>
            </div>
            <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>
          </div>
          <div className="cnt_hdr_top_rgt_wrap">
            <div title="Domain Section">
              <Select
                options={SectionOptions}
                name="name"
                onChange={SetSectionNameHandle}
                placeholder="Domain Section"
                styles={customDropdownStyles()}
                menuPortalTarget={document.body}
                classNamePrefix="common-domain-dropdown"
              />
            </div>
            <button
              title="Run Report"
              className="runreportnew over_all_accessibility"
              onClick={() => {
                if (first.statusDomain) {
                  setcheckD(first.statusDomain);
                } else {
                  setfaqData(2)
                  setToggle(false)
                  SetRunReportPopShow(true);
                }
              }}
              disabled={!sourcePlan.status}
              style={{ letterSpacing: "0.8px", width: "150px", lineHeight: "12px" }}
            >
              Run Report Now
            </button>
          </div>
        </div>


        {sourcePlan.status ?
          <div>

            <div className="cnt_hdr_content">
              <div className="box_wrap">
                <div>
                  <h1></h1>
                  <p></p>
                </div>
                <div className="common-card-container" style={{ justifyContent: "center" }}>
                  {cardDatas.map(({ title, value, iconSrc, altText }) => (
                    <Commoncard key={title} title={title} value={value} iconSrc={iconSrc} altText={altText} nonclikable={true} />
                  ))}
                </div>


              </div>
            </div>
            <DatagridComp
              columns={columns}
              rows={rows}
              autoheightval={autoheightval}
              datagridval={2}
              columnFreezeWidth={[0]}
              tableLoading={tableLoading}
            />
          </div> : <Freeaudit planStatus={sourcePlan} />
        } */}
        <Dialog
          open={modalIsOpen}
          onClose={closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="cnt_hdr_blw_wrap row">
                <div className="col">
                  <div>
                    <span>Completed Date</span>
                    <Select
                      value={dEngineoption}
                      options={completedate}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values)
                        SetdEngineoption(values);
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                    <span className="text-error">{validation.dateerror}</span>
                  </div>

                </div>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <button className="form_submit_btn" onClick={reportNow}>
              Submit
            </button>
            <button onClick={closeModal}>close</button>
            <button
              className="form_submit_btn"
              style={{ cursor: "pointer" }}
              onClick={handleReset}
            >
              Reset
            </button>
          </DialogActions>
        </Dialog>
        {!openCommonAlerts &&
          <>
            <CommonErrorAlert
              data={{
                apiopen: open,
                apiErrorMsg: 'No Data Found',
                isIconStyled: false
              }}
              closeAlert={handleClose} />
            <CommonErrorAlert
              data={{
                apiopen: apiopen,
                apiErrorMsg: apierrorMsg,
                isIconStyled: true
              }}
              closeAlert={apihandleClose} />
          </>
        }
        <Dialog
          open={checkD}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="domain-verify-alert"
        >
          <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Please verify your domain to access these features
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
            <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
          </DialogActions>
        </Dialog>
      </div>
      <RunReportNow
        RunReportPopShow={RunReportPopShow}
        SetRunReportPopShow={SetRunReportPopShow}
        RunReportType={RunReportType}
        isDomainSection={true}
      />
      <UserActivityTracker pagename="Technical - Source Code Analysis - Source code list" />
    </div>
  );
}
